import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseLogout {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec() {
        return await this.repository.onLogout()
    }
}